export default __webpack_public_path__ + "static/media/WDSscreenshot.9bdb3df8.PNG";